import { ValidationErrors } from '../../../lib/models/validation/validation-errors';
import { MortgageApplication } from './mortgage-application.model';

export class MortgageApplicationResponse {
  public mortgageApplicationEntity: MortgageApplication;
  public sections: any;
  public obsoleteFieldNotifications: any;
  public validationErrors: ValidationErrors;
  public isSubmitted = false;
  public hasSubmitValidationError?;
}
